import template from './teamCalendarMobile.html';
import controller from './teamCalendarMobile.controller';
import './teamCalendarMobile.scss';

let teamCalendarMobileComponent = {
  restrict: 'E',
  bindings: {
    isWageInProcess: '<'
  },
  template,
  controller
};

export default teamCalendarMobileComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarMobile.component.js